import { useSelector, useDispatch } from 'react-redux';
import { next } from '../../fsm/events';
import { getSettings, getUserDataEligibilityPdf } from '../../selectors/settings';
import { getIsMultiChannelMode } from '../../selectors/global';

const useConnect = () => {
  const dispatch = useDispatch();
  return {
    settings: useSelector(getSettings),
    isMultiChannelMode: useSelector(getIsMultiChannelMode),
    userDataEligibilityPdf: useSelector(getUserDataEligibilityPdf),
    next: () => dispatch(next()),
  };
};
export default useConnect;
